<template>
	<div :class="{ playbook__featured: featured }" :style="playbookStyle" class="playbook">
		<div>
			<playbooks-card-inspired-by>
				<template #name>
					{{ template.inspired_by }}
				</template>
				<template #increase>
					{{ template.increase }}
				</template>
			</playbooks-card-inspired-by>
			<playbooks-card-preview v-if="!featured" :template="template" />
			<playbooks-card-description>
				{{ template.playbook_description }}
			</playbooks-card-description>
			<playbooks-card-rules :rules="template.rules" />
			<playbooks-card-buttons v-if="featured" :template="template" :is-preview="false" />
			<div class="hire-expert">
				<a
					:href="
						$urls.utmLink($urls.marketing('vip-service/'), {
							utm_medium: 'Playbooks',
						})
					"
					target="_blank"
				>
					Hire an Expert
				</a>
			</div>
		</div>
		<templates-inline-preview-placeholder v-if="isInline" :template="template" />
	</div>
</template>

<script>
import { templatePreviewItem } from '../../templates/mixins/templatePreviewItem';

export default {
	mixins: [templatePreviewItem],
	props: {
		template: {
			type: Object,
			required: true,
		},
		featured: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		/**
		 * Background image for featured playbook cards.
		 *
		 * The image used for the smaller cards is the screenshot, however if it is the only playbook we will use the
		 * set featured image so that it can be different and to match the designs.
		 *
		 * @returns {string}  The background image CSS for the current playbook with the featured image's URL
		 */
		featuredBackground() {
			return this.template.image_url || '';
		},
		/**
		 * Generates the background image CSS value.
		 *
		 * @returns {string} The background image CSS property.
		 */
		playbookStyle() {
			return this.featured && this.featuredBackground
				? `background-image: url('${this.featuredBackground}')`
				: '';
		},
	},
	created() {
		this.addListeners();
	},
	beforeDestroy() {
		this.removeListeners();
	},
};
</script>
